import classNames from "classnames";
import React, { SVGAttributes } from "react";
import styled from "styled-components";
import { IconName } from "./style";

export type IconProps = {
  icon: IconName;
  xlinkHrefPrefix?: string;
  className?: string;
  title?: string;
  small?: boolean;
  large?: boolean;
  xlarge?: boolean;
  blue?: boolean;
  green?: boolean;
  red?: boolean;
  white?: boolean;
  grey?: boolean;
  round?: boolean;
  svgProps?: SVGAttributes<SVGElement>;
};

// This styled component is intentionally empty so we have something to export
// and use as a child selector elsewhere when necessary.
export const IconSvg = styled.svg``;

export const Icon: React.FC<IconProps> = ({
  icon,
  xlinkHrefPrefix,
  className,
  title,
  small,
  large,
  xlarge,
  blue,
  green,
  red,
  white,
  grey,
  round,
  svgProps,
}) => {
  const classes = classNames({
    "do-Icon": true,
    [className ?? ""]: className ?? false,
    "do-Icon--small": small,
    "do-Icon--large": large,
    "do-Icon--xlarge": xlarge,
    "do-Icon--blue": blue,
    "do-Icon--green": green,
    "do-Icon--red": red,
    "do-Icon--white": white,
    "do-Icon--grey": grey,
    "do-Icon--round": round,
    "do-Icon--product": icon.indexOf("product-") !== -1,
  });
  const prefix = typeof xlinkHrefPrefix === "string" ? xlinkHrefPrefix : "_sprite-";
  const generatedTitle = `${icon.replace(/-/g, " ")} icon`;
  // Most of our icons are used for decorative purposes and are hidden by default from screen
  // readers. If you pass in a role of 'img' or 'presentation', the icon will become accessible
  // to screen readers and a title will be generated for it. This is useful when an icon is not
  // accompanied by a label and is a standalone action trigger.
  const shouldBeVisibleToScreenReaders = svgProps?.role === "img" || svgProps?.role === "presentation";

  return (
    <IconSvg className={classes} aria-hidden={!shouldBeVisibleToScreenReaders} {...svgProps}>
      {shouldBeVisibleToScreenReaders && <title>{title || generatedTitle}</title>}
      <use xlinkHref={`#${prefix}${icon}`} />
    </IconSvg>
  );
};
